import RolesId from "../enums/RoleIds";

const getTabsByRole = (roleId: number) => {
  switch (roleId) {
    case RolesId.COUTNRY_MANAGER:
      return ["Self", "ZBM", "RBM", "ABM", "TSO"];
    case RolesId.ZONE_MANAGER:
      return ["Self", "RBM", "ABM", "TSO"];
    case RolesId.REGION_MANAGER:
      return ["Self", "ABM", "TSO"];
    case RolesId.AREA_MANAGER:
      return ["Self", "TSO"];
    case RolesId.HEADQUATER_MANAGER:
      return ["Self"];
    default:
      return ["Self"];
  }
};

export default getTabsByRole;